import React, { FunctionComponent } from 'react'
import { Sticker } from '../../types'
import StickerUnApprovedCauseCard from './StickerUnApprovedCauseCard'

const imgBorderColor = {
  red: '#ff6060',
  green: '#5fffaf',
  yellow: '#FFBF00',
  purple: '#a202ff',
}
type StickerWrapperProp = {
  sticker: Sticker
  imgBorder?: 'green' | 'red' | 'yellow' | 'purple'
}
const StickerWrapper: FunctionComponent<StickerWrapperProp> = ({
  children,
  sticker,
  imgBorder,
}) => {
  return (
    <div className="sticker-wrapper">
      <div className="un-approved-cause-card">
        {imgBorder === 'yellow' && (
          <StickerUnApprovedCauseCard
            position="top"
            unApprovedCauses={
              sticker.stickerInspectionData?.unapprovedCauses as any
            }
          />
        )}
      </div>
      <div className="sticker-container">
        <img
          style={
            imgBorder && { border: `4px solid ${imgBorderColor[imgBorder]}` }
          }
          className="sticker-list-item"
          alt="sticker-img"
          src={sticker.origin}
        />

        <span className="darkness"></span>
        <div className="sticker-icon-wrapper">{children}</div>
      </div>
    </div>
  )
}
export default StickerWrapper
